<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>


 
         <el-form-item label="返佣配置">
        <el-button size="small" type="primary" @click="addOrder">新增返佣配置</el-button>
        <el-table :data="form.commission_config" border size="mini" style="width: 100%;margin-top: 20px;">
          
          <el-table-column prop="type" label="身份" >
            <template v-slot="scope">
              <el-select v-model="scope.row.type" placeholder="请选择身份">
                <el-option label="默认" :value="0"></el-option>
                <el-option label="省代" :value="1"></el-option>
                <el-option label="市代" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>

            <el-table-column prop="code" label="类型" >
            <template v-slot="scope">
              <el-select v-model="scope.row.code" placeholder="请选择类型">
                <el-option label="余额充值" :value="1"></el-option>
                <el-option label="活动报名" :value="2"></el-option>
                <el-option label="短信充值" :value="3"></el-option>
                <el-option label="推广企业" :value="4"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="tg_count" label="推广人数" >
            <template v-slot="scope">
              <el-input type="number" v-model="scope.row.tg_count" placeholder="请输入推广人数"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="tg_discount" label="推广折扣(%)" >
            <template v-slot="scope">
              <el-input type="number" v-model="scope.row.tg_discount" placeholder="推广折扣"></el-input>
            </template>
          </el-table-column>

          <!-- 余额充值返佣 -->
          <el-table-column label="返佣" >
            <el-table-column prop="balance_level1" label="一级(%)" width="80">
              <template v-slot="scope">
                <el-input v-if="scope.row.code != 4" type="number" v-model="scope.row.fy1" placeholder="一级"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="balance_level2" label="二级(%)" width="80">
              <template v-slot="scope">
                <el-input v-if="scope.row.code != 4" type="number" v-model="scope.row.fy2" placeholder="二级"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="balance_level3" label="三级(%)" width="80">
              <template v-slot="scope">
                <el-input v-if="scope.row.code != 4" type="number" v-model="scope.row.fy3" placeholder="三级"></el-input>
              </template>
            </el-table-column>
          </el-table-column>

        


          <el-table-column prop="action" label="操作" >
            <template v-slot="scope">
              <el-button type="text" style="color: #F56C6C;" @click="delOrder(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <div style="color: #999; margin: 10px 0;">
        说明：折扣是指购买升级会员/充值短信/充值余额以折扣购买
      </div>



    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import TuiguangApi from '@/api/tuiguang.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
        commission_config:[],
      },
      setting: [],
      loading: false,
      isProductUpload:false,
           loading: false,
            kmdGradeArr:[{
                id:0,
                name:"默认返佣"
              },{
                id:1,
                name:"省代返佣"
              },{
                id:2,
                name:"市代返佣"
            }],
            agent_type:0
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
          delOrder(index){
        this.form.commission_config.splice(index,1)
    },
      addOrder(){
        this.form.commission_config.push({
          type:0,
          code:1,
          tg_count: '',
          tg_discount: '',
          fy1:0,
          fy2:0,
          fy3:0
          
        });
      },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      TuiguangApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
            if(! self.form.commission_config){
              self.form.commission_config = [];
            }
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      TuiguangApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/tuiguang/setting/getSetting.vue